export default "__VITE_ASSET__7vpbEf4m__"